import React, { useEffect } from 'react';
import Page from "./layout/Page";
import Card from "./layout/Card";
import {useLocation} from "react-router-dom";
import CallListRow from "./call/ListRow";
import CallBtns from './call/CallBtns';

import { useNavigate } from 'react-router-dom';
import {ucwords} from "../utils";
import Loader from './layout/Loader';
import {getContent} from "../api";
import {showError, fetchWithRetry} from "../utils";
import {formatDateLabel, prepareCallObject} from "./call/call-utils";

function CallChildren({itemGroup}){
    
    const [subitems, setSubItems] = React.useState([]);
   
    React.useEffect(() => {
        if (!itemGroup.childrenCalls || itemGroup.childrenCalls.length === 0) {
            // Se non ci sono chiamate figlie, non fare nulla
            setSubItems([]);
            return;
        }

        setSubItems([
            {
                ...itemGroup,
                count: 1,
                isCallDetails: true,
            },
            ...itemGroup.childrenCalls.map(child => ({
                ...child,
                count: 1,
                isCallDetails: true,
            }))
        ]);
    }, [itemGroup]);   
    
    
    const callCount = itemGroup.count; // Include la chiamata principale

    if(callCount == 1){
        return null;
    }

    const content = (
        <div className="call-children">
            <div className="call-children-num">{callCount} chiamate</div>
            {subitems.map((child, key) => (
                <CallListRow 
                    key={child.id + "-" + key}
                    itemGroup={child}
                    setRawList={setSubItems}                    
                />
            ))}
        </div>
    );

    return <Card content={content} />;

}


export default function Chiamata() {
    const location = useLocation();
    const { itemGroup } = location.state || {};

    const [isLoading, setLoading] = React.useState(false);
    const [chiamata, setChiamata] = React.useState(null);

     // Carica dati iniziali
    useEffect(() => {
        let ignore = false;
        const loadInitialData = async () => {
            setLoading(true);
            if (itemGroup) {
                // Carica la chiamata
                let chiamataData = await getContent("/chiamata/id/" + itemGroup.id);                 
                if(chiamataData && chiamataData.chiamata){
                    if (itemGroup.childrenCalls && itemGroup.childrenCalls.length > 0) {
                        for (let child of itemGroup.childrenCalls) {
                            const childData = await getContent("/chiamata/id/" + child.id);
                            if (childData && childData.chiamata) {
                                // Aggiungi i dati della chiamata figlia
                                chiamataData.chiamata.childrenCalls = chiamataData.chiamata.childrenCalls || [];
                                chiamataData.chiamata.childrenCalls.push(prepareCallObject(childData.chiamata));
                                chiamataData.chiamata.count = (chiamataData.chiamata.count || 1) + 1; // Incrementa il conteggio delle chiamate
                            }
                        }
                    }
                }

                if (ignore) return; // Ignora se il componente è stato smontato

                setChiamata(prepareCallObject(chiamataData?.chiamata));
            }
        };
        

        fetchWithRetry(loadInitialData, ignore)
        .catch(err => {
            if (!ignore) {
                showError('Errore nel caricamento dati iniziali: ' + err.message);
            }
        })
        .finally(() => {
            if (!ignore) {
                setLoading(false);
            }
        });

        return () => {
            ignore = true; // Imposta ignore a true quando il componente viene smontato
        }
    }, []);

    if (isLoading) {
        return <Page title="Chiamata">
                    <Loader/>
                </Page>     
        ;
    }

    if(!chiamata){
        return (
            <Page title="Chiamata">
                <Card title="Errore" content="Chiamata non trovata" variant="error" />
            </Page>
        );
    }

    let chiamante_title_lower = ucwords(chiamata.chiamante_title);
    let parlato_con_lower = ucwords(chiamata.parlato_con);

    const callerInfo = (
        <div className="call-info">
            <div className="datetime">{chiamata.day} {chiamata.lastCallTime}</div>
            <div className="chiamante">{chiamante_title_lower}</div>
            <div className="parlatocon">{parlato_con_lower}</div>
        </div>
    );

    return (
        <Page title="Chiamata">
            <Card content={callerInfo} />
            <div style={{padding: '1rem'}}>
                <div className="vista-row-actions">
                    <CallBtns itemGroup={chiamata} infoBtnTarget="contatto" />
                </div>
            </div>
            <CallChildren itemGroup={chiamata}/>
        </Page>
    );
}